<template>
    <div
        class="pdf-scroll-document"
        :class="{'scrolling': isScrolling}"
        ref="pdf-scroll-document"
        @scroll="isScrolling = true"
        v-scroll.immediate="updateScrollBounds"
    >
        <template v-for="page in pages">
            <pdf-scroll-page
                v-bind="{ page, scrollTop, clientHeight, currentPage, scale, isToBottom, isImage, dragInfo, isScrolling, watermarkText }"
                @update-scroll-top="onUpdateScrollTop"
                :key="get_uid(page)"
            >
                <template #default="scope">
                    <slot v-bind="scope"></slot>
                </template>
            </pdf-scroll-page>
        </template>
    </div>
</template>

<script>
import PdfScrollPage from './pdf-scroll-page';
import scroll from '../directives/scroll';
import { get_uid } from '../utils/base';
export default {
    name: 'PdfScrollDocument',
    components: { PdfScrollPage },
    props: {
        pageCount: Number,
        pages: Array,
        currentPage: Number,
        scale: Number,
        isImage: Boolean,
        dimensions: Array,
        dragInfo: Object,
        watermarkText: String,
    },
    data () {
        return {
            scrollTop: 0,
            clientHeight: 0,
            scrollLeft: 0,
            isToBottom: false,
            isScrolling: false,
            get_uid
        };
    },
    directives: { scroll },
    methods: {
        /** 更新当前滚动距离 */
        updateScrollBounds () {
            const { scrollTop, clientHeight, scrollLeft } = this.$el;
            this.isToBottom = this.scrollTop < scrollTop;
            this.scrollTop = scrollTop;
            this.scrollLeft = scrollLeft;

            this.clientHeight = clientHeight;
            this.isScrolling = false;

            this.$emit('scroll-callback', this.scrollTop, this.scrollLeft);
        },

        /** 更新滚动条位置 */
        onUpdateScrollTop (scrollTop) {
            this.$el.scrollTop = scrollTop;
        },

        onUpdateScrollLeft (scrollLeft = 0) {
            this.$el.scrollLeft = scrollLeft;
        }
    },
};
</script>

<style lang="less" scoped>
.pdf-scroll-document {
    position: relative;
    height: 100%;
    margin: 0 auto;
    overflow: auto;

    /*滚动条样式*/
    &::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 8px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 8px;
    }

    &::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px #c1c6cd;
        box-shadow: inset 0 0 5px #c1c6cd;
        background: #c1c6cd;
    }

    &::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        -webkit-box-shadow: none;
        box-shadow: none;
        border-radius: 0;
        background: transparent;
    }
}
</style>
